import { GreyStrip } from "../Atoms/GreyStrip";
import { CreateTasks } from "./CreateTasks";
import { useTranslation } from "@coworker/locales";
import { MediasAndArticleCountResponse } from "../types/media";
import { MediaTask } from "@coworker/types/lib/tasks/media";

interface ArticleTasksSectionProps {
  mediasArticleCount: MediasAndArticleCountResponse[];
  tasks: MediaTask[];
  currentArticleId?: string;
}

export const ArticleTasksSection = ({
  mediasArticleCount,
  tasks,
  currentArticleId,
}: ArticleTasksSectionProps) => {
  const { t } = useTranslation();

  return (
    <>
      <GreyStrip text={t("foundInFollowingMediasString")} />
      <CreateTasks
        mediasArticleCount={mediasArticleCount}
        tasks={tasks}
        currentArticleId={currentArticleId}
      />
    </>
  );
};
